import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <p>&copy; 2025 Siddhi Dhamnaskar. All rights reserved.</p>
          </div>
          <div className="footer-right">
            <div className="social-links">
              <a href="https://github.com/siddhidhamnaskar" target="_blank" rel="noopener noreferrer">GitHub</a>
              <a href="https://www.linkedin.com/in/siddhi-dhamnaskar/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              <a href="mailto:siddhidhamnaskar@gmail.com">Email</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
